import { useCallback } from 'react';

import { PlayerProps } from '../types';

interface UseOnFinishParams {
    contentId: PlayerProps['contentId'];
    onFinish: PlayerProps['onFinish'];
}

export const useOnFinish = (params: UseOnFinishParams): (() => void) => {
    const { contentId, onFinish } = params;

    const handleFinish = useCallback(() => {
        if (contentId) {
            onFinish?.(contentId);
        }
    }, [onFinish, contentId]);

    return handleFinish;
};
